<template>
  <Dialog :commonDialog="bDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage Salary Type </v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            small
            class="mx-4 white--text"
            color="cyan"
            v-on:click="createSalaryType"
          >
            <span class="font-size-16 font-weight-600">Add Salary Type</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="ticketCollecttionForm"
          lazy-validation
          v-on:submit.stop.prevent="updateProductBrand"
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody v-for="(type, index) in salaryType" :key="index">
                    <tr>
                      <td colspan="2">
                        <v-text-field
                          v-model.trim="type.type"
                          dense
                          filled
                          placeholder="Salary Type"
                          solo
                          flat
                          class="px-2 py-1"
                          hide-details
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          :rules="[
                            validateRules.required(type.type, 'Salary Type'),
                          ]"
                          color="cyan"
                        />
                      </td>
                      <td
                        width="50"
                        v-if="salaryType.length > 1"
                        class="text-center"
                      >
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              @click="deleteHourType(index)"
                              color="deep-orange"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        :disabled="pageLoading"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateSalaryType"
      >
        Save
      </v-btn>
      <v-btn
        depressed
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
// import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep } from "lodash";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    bDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    salaryType: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
    /* existCategory: {
          type: String,
          default: null,
        }, */
  },
  watch: {
    salaryType: {
      deep: true,
      immediate: true,
      handler(param) {
        this.serviceList = cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      pageLoading: false,
      serviceList: [
        {
          text: null,
        },
      ],
    };
  },
  methods: {
    // showAddFields(index) {
    //   this.$set(this.viewAddButton, index, !this.viewAddButton[index]);
    // },
    updateSalaryType() {
      const _this = this;

      _this.pageLoading = true;
      _this.$store;
      _this.$store;
      _this.$store
        .dispatch(PATCH, {
          url: "update-salary-type",
          data: { salary_value: _this.serviceList },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-service-type", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createSalaryType() {
      this.salaryType.push({
        text: null,
      });
    },
    deleteHourType(index) {
      if (this.salaryType.length > 1) {
        this.salaryType.splice(index, 1);
      }
    },

    // isHourVisible(event, id) {
    //   const _this = this;
    //   _this.$store
    //     .dispatch(PATCH, {
    //       url: "update-hour-visiblity",
    //       data: { service_type_id: id, is_hours_visible: event },
    //     })
    //     .then(() => {
    //       // _this.$emit("close-dialog", true);
    //       _this.$emit("get-service-type", true);
    //       // ProductBrandEventBus.$emit("refress-brand", true);
    //     })
    //     .catch((error) => {
    //       _this.logError(error);
    //     })
    //     .finally(() => {
    //       _this.pageLoading = false;
    //     });
    // },
    // isHouseVisible(event, id) {
    //   const _this = this;
    //   _this.$store
    //     .dispatch(PATCH, {
    //       url: "update-house-visiblity",
    //       data: { service_type_id: id, is_house_type_visible: event },
    //     })
    //     .then(() => {
    //       // _this.$emit("close-dialog", true);
    //       _this.$emit("get-service-type", true);
    //       // ProductBrandEventBus.$emit("refress-brand", true);
    //     })
    //     .catch((error) => {
    //       _this.logError(error);
    //     })
    //     .finally(() => {
    //       _this.pageLoading = false;
    //     });
    // },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
